import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { verifyMagicLink } from '../api/auth';
import { Spinner } from '../components/ui/Spinner';
import { Card } from '../components/ui/Card';

export function AuthVerifyPage() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { login } = useAuth();

  const token = searchParams.get('token');

  useEffect(() => {
    async function verify() {
      if (!token) {
        setError('No verification token provided');
        return;
      }

      try {
        const response = await verifyMagicLink(token);
        login(response.session.token, response.user);
        navigate('/', { replace: true });
      } catch (err) {
        const message = err instanceof Error ? err.message : 'Verification failed';
        setError(message);
      }
    }

    verify();
  }, [token, login, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900">niftee</h1>
            <p className="text-gray-600 mt-2">Agency Dashboard</p>
          </div>

          <Card padding="lg">
            <div className="text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">
                Verification Failed
              </h2>
              <p className="text-gray-600 mb-6">{error}</p>
              <button
                onClick={() => navigate('/login')}
                className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700"
              >
                Back to Login
              </button>
            </div>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">niftee</h1>
          <p className="text-gray-600 mt-2">Agency Dashboard</p>
        </div>

        <Card padding="lg">
          <div className="text-center">
            <Spinner size="lg" />
            <p className="text-gray-600 mt-4">Verifying your sign-in link...</p>
          </div>
        </Card>
      </div>
    </div>
  );
}
